import { render, staticRenderFns } from "./DialogAvatar.vue?vue&type=template&id=24d98bda&scoped=true"
import script from "./DialogAvatar.vue?vue&type=script&lang=js"
export * from "./DialogAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d98bda",
  null
  
)

export default component.exports